import { getLogger } from "@expert/logging";

import { getGamificationApiClient } from "@/sales-tools/api/api";

const logger = getLogger({ module: "morningPaperDismissalApi" });

export interface DismissalStatusResponse {
    dismissed: boolean;
    dismissedAt: string | null;
}

/**
 * Check if morning paper has been dismissed for today's business date.
 * The server calculates the business date in America/Chicago timezone.
 */
export async function getDismissalStatus(): Promise<DismissalStatusResponse> {
    try {
        const response = await getGamificationApiClient()
            .get("v1/morning-paper/dismissal-status", {
                retry: {
                    limit: 3,
                    methods: ["get"],
                },
            })
            .json<DismissalStatusResponse>();

        return response;
    } catch (error) {
        logger.error({ error }, "Failed to fetch morning paper dismissal status after retries");
        // On error, assume already dismissed to avoid forcing unwanted logout (fail closed)
        return { dismissed: true, dismissedAt: null };
    }
}

/**
 * Record morning paper dismissal for today's business date.
 * The server calculates the business date in America/Chicago timezone.
 */
export async function dismissMorningPaper(): Promise<void> {
    try {
        await getGamificationApiClient()
            .post("v1/morning-paper/dismiss", {
                retry: 0,
            })
            .json();

        logger.info("Morning paper dismissal recorded successfully");
    } catch (error) {
        logger.error({ error }, "Failed to record morning paper dismissal");
        throw error;
    }
}
